import { useCallback } from "react";
import { useHubSpotAdapterAxiosInstance } from "./useHubSpotAdapterAxiosInstance.ts";
import { useWithLoading } from "../UI/Loading/useWithLoading.ts";

export type HubSpotSalesMemberDTO = {
  id: string;
  email: string;
};

export function useGetHubSpotSalesMembers() {
  const axiosInstance = useHubSpotAdapterAxiosInstance();
  const { withLoading, loading } = useWithLoading<HubSpotSalesMemberDTO[]>();

  const getMembersCall = useCallback(async () => {
    const { data } = await axiosInstance.get<HubSpotSalesMemberDTO[]>(
      `/closer-availability/members`,
    );
    return data;
  }, [axiosInstance]);

  const getHubSpotSalesMembers = useCallback(async () => {
    return await withLoading(() => getMembersCall());
  }, [withLoading, getMembersCall]);

  return {
    getHubSpotSalesMembers,
    loading,
  };
}
